import React from 'react';

export const ScrollToTopContext = React.createContext({ scrollToTop: () => void 0 });

export const useScrollToTop = () => React.useContext(ScrollToTopContext);
